import { render, staticRenderFns } from "./CompliancePieChart.vue?vue&type=template&id=08541f4e"
import script from "./CompliancePieChart.vue?vue&type=script&lang=js"
export * from "./CompliancePieChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports